const testimonials = [
  {
    id: 1,
    rating: 5,
    title: 'Servicio excepcional y rápido',
    text: 'Tuve una emergencia con una fuga en la cocina y llegaron en menos de una hora. El trabajo fue impecable y el precio muy justo. Totalmente recomendados para cualquier problema de fontanería.',
    name: 'María González',
    role: 'Cliente desde 2020',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20hispanic%20woman%20portrait%20smiling%20friendly%20face%20business%20casual%20attire%20clean%20white%20background%20happy%20customer%20satisfied%20client%20brown%20hair%20professional%20headshot&width=200&height=200&seq=testimonial-avatar-maria-001&orientation=squarish'
  },
  {
    id: 2,
    rating: 5,
    title: 'Profesionales de confianza',
    text: 'Contraté sus servicios para la instalación completa de tuberías en mi nueva casa. El equipo fue muy profesional, limpio y eficiente. El resultado superó mis expectativas.',
    name: 'Carlos Rodríguez',
    role: 'Cliente desde 2018',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20hispanic%20man%20portrait%20smiling%20confident%20businessman%20wearing%20glasses%20business%20casual%20shirt%20clean%20white%20background%20happy%20customer%20satisfied%20client%20professional%20headshot&width=200&height=200&seq=testimonial-avatar-carlos-002&orientation=squarish'
  },
  {
    id: 3,
    rating: 5,
    title: 'Excelente relación calidad-precio',
    text: 'Después de probar con otros fontaneros, encontré en ellos la solución perfecta. Son puntuales, honestos y su trabajo es de primera calidad. Ya los he recomendado a varios amigos.',
    name: 'Ana Martínez',
    role: 'Cliente desde 2019',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20young%20woman%20portrait%20smiling%20friendly%20blonde%20hair%20business%20casual%20blazer%20clean%20white%20background%20happy%20customer%20satisfied%20client%20professional%20headshot&width=200&height=200&seq=testimonial-avatar-ana-003&orientation=squarish'
  },
  {
    id: 4,
    rating: 5,
    title: 'Remodelación perfecta',
    text: 'Remodelaron completamente mi baño y quedó espectacular. Desde el diseño hasta la instalación, todo fue perfecto. Son verdaderos expertos en su campo.',
    name: 'Luis Fernández',
    role: 'Cliente desde 2021',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20mature%20man%20portrait%20smiling%20confident%20beard%20business%20casual%20polo%20shirt%20clean%20white%20background%20happy%20customer%20satisfied%20client%20professional%20headshot&width=200&height=200&seq=testimonial-avatar-luis-004&orientation=squarish'
  },
  {
    id: 5,
    rating: 5,
    title: 'Servicio 24/7 confiable',
    text: 'Llamé a medianoche por una emergencia y respondieron inmediatamente. Su disponibilidad 24/7 es real y su servicio es excepcional. Me salvaron de un gran problema.',
    name: 'Isabel Torres',
    role: 'Cliente desde 2022',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20middle%20aged%20woman%20portrait%20smiling%20friendly%20red%20hair%20business%20casual%20sweater%20clean%20white%20background%20happy%20customer%20satisfied%20client%20professional%20headshot&width=200&height=200&seq=testimonial-avatar-isabel-005&orientation=squarish'
  },
  {
    id: 6,
    rating: 5,
    title: 'Mantenimiento impecable',
    text: 'Contrato su servicio de mantenimiento preventivo anual y gracias a eso no he tenido ningún problema. Son muy detallistas y siempre me explican todo claramente.',
    name: 'Roberto Sánchez',
    role: 'Cliente desde 2017',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20senior%20man%20portrait%20smiling%20confident%20gray%20hair%20business%20casual%20jacket%20clean%20white%20background%20happy%20customer%20satisfied%20client%20professional%20headshot&width=200&height=200&seq=testimonial-avatar-roberto-006&orientation=squarish'
  }
];

export default function Testimonials() {
  return (
    <section id="testimonios" className="py-16 sm:py-20 lg:py-24 bg-[#EFF6FF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <div className="flex items-center justify-center gap-2 mb-3 sm:mb-4">
            <div className="w-2 h-2 rounded-full bg-[#3B82F6]"></div>
            <span className="text-gray-600 text-xs sm:text-sm font-medium">Opiniones</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#1e3a8a] mb-3 sm:mb-4 px-4">
            Lo Que Dicen Nuestros Clientes
          </h2>
          <p className="text-sm sm:text-base text-gray-600">
            Más de 5000 clientes satisfechos confían en nosotros
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-md hover:shadow-xl transition-all duration-300 ${
                index >= 3 ? 'opacity-100' : ''
              }`}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-3 sm:mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <div key={i} className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-[#3B82F6] text-base sm:text-lg"></i>
                  </div>
                ))}
              </div>

              {/* Title */}
              <h3 className="text-base sm:text-lg font-semibold text-[#1e3a8a] mb-2 sm:mb-3 line-clamp-2">
                {testimonial.title}
              </h3>

              {/* Review Text */}
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed mb-4 sm:mb-6 line-clamp-4">
                {testimonial.text}
              </p>

              {/* User Info */}
              <div className="flex items-center gap-3 pt-4 sm:pt-6 border-t border-gray-100">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full overflow-hidden border-2 border-[#3B82F6]/20 flex-shrink-0">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="text-sm sm:text-base font-semibold text-[#1e3a8a]">
                    {testimonial.name}
                  </div>
                  <div className="text-xs sm:text-sm text-gray-500">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
